/* eslint-disable react/jsx-props-no-spreading */
import React, { forwardRef, InputHTMLAttributes } from 'react';

// https://css-tricks.com/auto-growing-inputs-textareas/
const AutoGrowingInput = forwardRef<HTMLInputElement, InputHTMLAttributes<HTMLInputElement>>(
  (props, ref): JSX.Element => {
    const { value, placeholder } = props;
    return (
      <div className="ver-search__input-wrapper">
        <span aria-hidden className="ver-search__input-width">
          {value || placeholder}
        </span>
        <input {...props} ref={ref} className="ver-search__input" />
      </div>
    );
  },
);

export default AutoGrowingInput;
